module.exports = __webpack_public_path__ + "img/status4.d3fc69a4.png";